import { render, staticRenderFns } from "./cscenter-top-component.vue?vue&type=template&id=06063b52&scoped=true&"
import script from "./cscenter-top-component.vue?vue&type=script&lang=js&"
export * from "./cscenter-top-component.vue?vue&type=script&lang=js&"
import style0 from "./cscenter-top-component.vue?vue&type=style&index=0&id=06063b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06063b52",
  null
  
)

export default component.exports